(function($){

// hideheader();
var scrollingup=false;
var menushowing=true;
var lastScrollTop = 0;
var fixmenu=160;
var scrollStart = $(this).scrollTop();







window.onload = function() {
           hasScrolled();
           // heroDelay();
};
//don't load hidden elements when not needed
// Define your mobile breakpoint (e.g., 768px)
 // const mobileBreakpoint = 768;
 //    const isMobile = window.innerWidth < mobileBreakpoint;

 //    const cleanDOM = () => {
 //        if (isMobile) {
 //            // We are on MOBILE: Remove elements intended only for DESKTOP/LARGE screens
 //            document.querySelectorAll('.block-visibility-hide-large-screen').forEach(el => el.remove());
 //        } else {
 //            // We are on DESKTOP: Remove elements intended only for MOBILE/SMALL screens
 //            document.querySelectorAll('.block-visibility-hide-medium-screen, .block-visibility-hide-small-screen').forEach(el => el.remove());
 //        }
 //    };

 //    // Run immediately if DOM is ready, otherwise wait for DOMContentLoaded
 //    if (document.readyState === 'loading') {
 //        document.addEventListener('DOMContentLoaded', cleanDOM);
 //    } else {
 //        cleanDOM();
 //    }
 // Contact page - Scroll to target after reload if "station" parameter is present
// window.addEventListener('load', () => {
//       const params = new URLSearchParams(window.location.search);
//       const station = params.get('station');

//       if (station) {
//         // console.log(`Station parameter received: ${station}`);

//         const target = document.getElementById('contact_station');
//         if (target) {
//           target.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }

//         // Optional: do something with the station value
//         // e.g., document.body.dataset.station = station;
//       }
//     });

window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);
  const station = params.get('station');

  if (station) {
    const target = document.getElementById('contact_station');
    if (target) {
      const fixedHeaderHeight = 240; // Adjust this to your header's height
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = targetPosition - fixedHeaderHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }


  }
});
// function heroDelay(){
//     // console.log('hero delay');
//     setTimeout(function() {
//     heroAnimation();
//   }, 500 );
// }
// function heroAnimation(){
//     var isHomepage = document.getElementsByClassName('animated-hero');
// if (isHomepage.length > 0) {
//       pagehero.classList.add('ani-start'); 
// }

// }




function noBanner(){
    // console.log("no banner on page");
    var $menufloat = $('body').find('.wp-block-group.menu');
    if ($menufloat!= null) {
    $menufloat.addClass('menu-float');
    $menufloat.removeClass('menu-land');
    }
  
 }


function menuFloat(){
     var $menufloat = $('body').find('.wp-block-group.menu');
    if ($menufloat!= null) {
    $menufloat.addClass('menu-float');
    $menufloat.removeClass('menu-land');
    $menufloat.addClass('fadein');
    $menufloat.removeClass('fadeout');
    }

  
 }

function menuLand(){
    // console.log("menuland");
  // if( $("header").hasClass( "ctrl-noheader" ) ){
  //           noBanner();
  //   }

  //   else {
    var $menuland = $('body').find('.wp-block-group.menu');
    if ($menuland!= null) {
    $menuland.addClass('menu-land');
      $menuland.removeClass('menu-float');
      // $menuland.removeClass('bg-white');
    // }
    }
  

    
}
function menuAppear(){
  // console.log('menuAppear');
  menushowing=true;
var $showmenu = $('body').find('.wp-block-group.menu');
if ($showmenu!= null) {
   $showmenu.addClass('fadein');
    $showmenu.removeClass('fadeout');
     // $showmenu.addClass('bg-white');
}
    
var $showlogo = $('body').find('.wp-block-group.logo');
  if ($showlogo!= null) {
      $showlogo.addClass('fadein');
    $showlogo.removeClass('fadeout');
    }
  
   
}

function menuDisappear(){
    // console.log('menuDisappear');
  menushowing=false;
  var $hidemenu = $('body').find('.wp-block-group.menu');
   if ($hidemenu!= null) {
    $hidemenu.removeClass('fadein');
    $hidemenu.addClass('fadeout');
    // $hidemenu.removeClass('bg-white');
   }
    
}
function hasScrolled() {
    var st = $(this).scrollTop();
    var windowsize = $(window).width();
    var hideNum = 456;



//mobile
if (windowsize < 979)  {
     menuFloat();
   }
else {
    //desktop

     if (lastScrollTop > fixmenu){   
   menuFloat();
   }
  }
 if(st<=lastScrollTop){
    scrollingup=true;
          // console.log('scrolling up' );
          // console.log('st = ' + st );
          // console.log('hideNum'+ hideNum );
   
          if (menushowing==false){
             menuAppear();
          }
    
          //if section nav is open then close it
 
     if  (lastScrollTop > fixmenu){
      menuFloat();
        }
        else {
            menuLand();
        }
     if (st > hideNum){
   
     }
        
     //scrolling up
      
  }


  else if(st>lastScrollTop){
        //scrolling down
      scrollingup=false;
      //used if we want sidenav to change colour on scroll
     
     
     if (st > hideNum){
         menuDisappear();
     }
        
   

    
      
     

  }
  lastScrollTop = st;  


}


function removeThirdShareOption() {
  const selectElement = document.getElementById("prayerengine_desired_share_option");
  // Check if the element exists and has at least 3 options (index 0, 1, and 2)
  if (selectElement && selectElement.options.length >= 3) {
    selectElement.remove(2); // Remove the option at index 2 (the third option)
    // console.log("Third option removed successfully.");
  } else if (!selectElement) {
    // console.error("Select element with ID 'prayerengine_desired_share_option' was not found.");
  } else {
    // console.log("Dropdown does not have a third option to remove.");
  }
}


// Call the function when needed, for example after the page loads

if (document.getElementById('prayerengine_desired_share_option')) {
   removeThirdShareOption();
  } else {
    // console.log(`ID "prayerengine_desired_share_option}" not found on the page. Function not executed.`);
  }

$(window).on('scroll', function() {
hasScrolled();
});

})(jQuery);



//triggers animations on blocks (css)
document.addEventListener('DOMContentLoaded', () => {
  const animatedElements = document.querySelectorAll('.animated-element');
  const observerOptions = {
    root: null, // observe against the viewport
    rootMargin: '0px',
    threshold: 0.3 // Trigger when 20% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Element is in the viewport, add the class to trigger animations
        entry.target.classList.add('in-viewport');
        // Optionally, stop observing after the animation is triggered once
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  animatedElements.forEach(element => {
    observer.observe(element);
  });
});

jQuery(document).ready(function($) {

  /* ============================================================
     CONFIG: Set your offsets here (desktop + mobile)
     ============================================================ */

  // When arriving from another page
  var headerHeightDesktop = 309;
  var headerHeightMobile  = 40;

  // When clicking an anchor on the same page
  var clickOffsetDesktop  = 285;
  var clickOffsetMobile   = 180;

  // When clicked element is inside a .no-offset wrapper
  var reducedDesktop      = 120;
  var reducedMobile       = 60;

  /* ============================================================
     Automatically choose correct values based on screen width
     ============================================================ */

  function isMobile() {
    return window.innerWidth < 768; // change breakpoint if needed
  }

  function getHeaderHeight() {
    return isMobile() ? headerHeightMobile : headerHeightDesktop;
  }

  function getClickOffset() {
    return isMobile() ? clickOffsetMobile : clickOffsetDesktop;
  }

  function getReducedOffset() {
    return isMobile() ? reducedMobile : reducedDesktop;
  }

  /* ============================================================
     NORMALIZE PATH
     ============================================================ */

  function normalizePath(path) {
    if (!path) return '/';
    var p = path.split('?')[0].split('#')[0];
    if (p.length === 0) return '/';
    return (p.charAt(0) === '/' ? '' : '/') + p.replace(/\/+$/, '') || '/';
  }

  /* ============================================================
     SCROLL FUNCTION
     ============================================================ */

  function scrollToHash(hash, offsetAmount, behavior) {
    var $target = $(hash);
    if ($target.length === 0) return false;

    var raw = $target.offset().top;
    var final = raw - offsetAmount;

    // console.log("scrollToHash:", hash, "raw:", raw, "offset:", offsetAmount, "final:", final);

    if (behavior === 'smooth') {
      $('html, body').stop().animate({ scrollTop: final }, 500, 'swing', function() {
        history.replaceState(null, null, hash);
      });
    } else {
      $('html, body').stop().scrollTop(final);
      history.replaceState(null, null, hash);
    }

    return true;
  }

  /* ============================================================
     CLICK HANDLER
     ============================================================ */

  $('a[href*="#"]').on('click', function(event) {
    var href = this.getAttribute('href');
    if (!href) return;

    var parsed;
    try {
      parsed = new URL(href, window.location.href);
    } catch (e) {
      return;
    }

    var hash = parsed.hash;
    if (!hash) return;

    var linkPath = normalizePath(parsed.pathname);
    var currentPath = normalizePath(location.pathname);
    var sameOrigin = parsed.origin === location.origin;
    var isSamePage = sameOrigin && (linkPath === currentPath) || (href.charAt(0) === '#');

    if (isSamePage) {
      event.preventDefault();

      // Choose offset depending on `.no-offset`
      var $clicked = $(this);
      var offsetAmount = $clicked.closest('.no-offset').length
        ? getReducedOffset()
        : getClickOffset();

      // mark scroll handled for same-page
      sessionStorage.setItem('anchorScrollHandled', 'true');
      sessionStorage.setItem('anchorScrollPath', currentPath);

      history.replaceState(null, null, " ");
      scrollToHash(hash, offsetAmount, 'smooth');
      return;
    }

    // console.log("Cross-page anchor → let normal navigation happen:", href);
  });

  /* ============================================================
     ONLOAD HASH SCROLL
     ============================================================ */

  window.addEventListener('load', function() {
    var handled = sessionStorage.getItem('anchorScrollHandled') === 'true';
    var handledPath = sessionStorage.getItem('anchorScrollPath');
    var current = normalizePath(location.pathname);

    if (handled && handledPath === current) {
      console.log("Skipping onload scroll (already handled).");
      sessionStorage.removeItem('anchorScrollHandled');
      sessionStorage.removeItem('anchorScrollPath');
      return;
    }

    sessionStorage.removeItem('anchorScrollHandled');
    sessionStorage.removeItem('anchorScrollPath');

    if (location.hash) {
      var $target = $(location.hash);
      if ($target.length === 0) return;

      // console.log("Onload offset scroll:", location.hash);
      scrollToHash(location.hash, getHeaderHeight(), 'instant');
    }
  });

});

